/*
  BIBLIODOR — suggestions dans le panier latéral (« Souvent lus ensemble »).
  Tant que le client n'a pas 3 ebooks (offre « 2 achetés, le 3e offert »), le panier propose
  jusqu'à 2 livres liés à ceux déjà choisis, ajoutables en un geste. Au-delà, il s'efface
  pour laisser toute la place au paiement. Fichier autonome : se branche sur le panier
  existant (bibliodor.js) sans le modifier.
*/
(() => {
  const drawer = document.querySelector('[data-drawer]');
  const box = drawer && drawer.querySelector('[data-drawer-reco]');
  const dataEl = document.getElementById('bibliodor-catalogue');
  if (!drawer || !box || !dataEl) return;

  let catalogue = [];
  try { catalogue = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!catalogue.length) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const list = box.querySelector('[data-drawer-reco-list]');
  const title = box.querySelector('[data-drawer-reco-title]');
  const byHandle = new Map(catalogue.map((b) => [b.h, b]));
  const byVariant = new Map(catalogue.map((b) => [String(b.v), b]));

  const esc = (v) => String(v).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const money = (c) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(c / 100);
  const split = (t) => {
    const parts = String(t).split(' — ');
    return parts.length > 1 ? { num: parts[0], name: parts.slice(1).join(' — ') } : { num: '', name: t };
  };

  const pick = (cart) => {
    const inCart = new Set(cart.items.map((i) => String(i.variant_id)));
    const out = [];
    const add = (b) => { if (b && !inCart.has(String(b.v)) && !out.includes(b)) out.push(b); };
    /* 1. Les livres liés au dernier livre ajouté, puis aux précédents */
    [...cart.items].reverse().forEach((item) => {
      const book = byVariant.get(String(item.variant_id));
      if (book) book.pair.forEach((h) => add(byHandle.get(h)));
    });
    /* 2. Complément : le reste du catalogue, dans l'ordre de la boutique */
    catalogue.forEach(add);
    return out.slice(0, 2);
  };

  const render = (cart) => {
    const ebooks = cart.items.filter((i) => (i.product_type || '').toLowerCase() === 'ebook').reduce((n, i) => n + i.quantity, 0);
    const hasFree = cart.items.some((i) => (i.line_level_discount_allocations || []).length > 0);
    if (!cart.item_count || ebooks >= 3 || hasFree) { box.hidden = true; return; }
    const picks = pick(cart);
    if (!picks.length) { box.hidden = true; return; }
    const prices = cart.items.filter((i) => (i.product_type || '').toLowerCase() === 'ebook').map((i) => i.original_price);
    const minInCart = prices.length ? Math.min(...prices) : 0;
    title.textContent = ebooks === 2 ? 'Ajoute un 3ᵉ livre : le moins cher est offert' : 'Souvent lus ensemble';
    list.innerHTML = picks.map((b) => {
      const s = split(b.t);
      const free = ebooks === 2 && b.p <= minInCart;
      return `<li class="drawer-reco__item">
        <a class="drawer-reco__img" href="${esc(b.u)}" tabindex="-1" aria-hidden="true">${b.i ? `<img src="${esc(b.i)}" alt="" width="56" height="56" loading="lazy">` : ''}</a>
        <div class="drawer-reco__info">
          ${s.num ? `<span class="drawer-reco__num">${esc(s.num)}</span>` : ''}
          <a class="drawer-reco__name" href="${esc(b.u)}">${esc(s.name)}</a>
          <span class="drawer-reco__price">${free ? `<b>Offert</b> <s>${money(b.p)}</s>` : money(b.p)}</span>
        </div>
        <button type="button" class="drawer-reco__add" data-reco-add="${esc(b.v)}" aria-label="Ajouter « ${esc(s.name)} » au panier">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>
          <span>Ajouter</span>
        </button>
      </li>`;
    }).join('');
    box.hidden = false;
  };

  const refresh = () =>
    fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then(render)
      .catch(() => { box.hidden = true; });

  /* Le panier existant réécrit la liste à chaque ouverture, ajout ou retrait : on suit ces changements. */
  const items = drawer.querySelector('[data-drawer-items]');
  let timer = null;
  new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(refresh, 60); }).observe(items, { childList: true });

  box.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-reco-add]');
    if (!btn) return;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    try {
      const r = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.recoAdd), quantity: 1 }] }),
      });
      if (!r.ok) throw new Error();
      const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((res) => res.json());
      document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = String(cart.item_count); el.hidden = cart.item_count === 0; });
      if (window.BIBLIODOR_OPEN_CART) window.BIBLIODOR_OPEN_CART(cart);
      const status = document.getElementById('cart-status');
      if (status) status.textContent = 'Ajouté au panier.';
    } catch (e) {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }
  });
})();

/* Bouton « Ajouter au panier » de la bibliothèque 3D (accueil) : ajout sans quitter la page, puis panier latéral. */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.bv__form');
    if (!form || !window.BIBLIODOR_OPEN_CART) return;
    event.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    const id = Number(form.querySelector('input[name="id"]').value);
    if (!id) return;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    try {
      const cart0 = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      if (!cart0.items.some((i) => i.variant_id === id)) {
        const r = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
        });
        if (!r.ok) throw new Error();
      }
      const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = String(cart.item_count); el.hidden = cart.item_count === 0; });
      window.BIBLIODOR_OPEN_CART(cart);
    } catch (e) {
      form.submit();
    } finally {
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    }
  });
})();
